import React from 'react';
import {Col, Row, Container, Form, InputGroup, Button} from "react-bootstrap";
import ErrorMessage from "./ErrorMessage";
import LoadingSpin from "./LoadingSpin";
import {Redirect} from "react-router-dom";
import {config} from "./Constants";

class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            submitError: null,
            isLoaded: true,
            isLoggedIn: false,
            isSubmitting: false,
            redirect: null,
            client: null
        };
        this.handleSubmitForm = this.handleSubmitForm.bind(this);
    }

    handleSubmitForm(event) {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        this.setState({
            isSubmitting: true
        });
        const formData = new FormData(event.target);
        let data = {};
        formData.forEach((val, mkey) => {
            data[mkey] = val;
        });
        fetch(config.API_URL + '/api/login', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            'method': 'POST',
            credentials: 'include',
            'body': JSON.stringify(data)
        })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.error) {
                        this.setState({
                            isSubmitting: false,
                            submitError: result.error
                        });
                    } else if (result) {
                        this.setState({
                            isSubmitting: false,
                            redirect: '/'
                        });
                    }
                },
                (error) => {
                    this.setState({
                        isSubmitting: false,
                        submitError: error
                    });
                }
            );
        return false;
    }

    render() {
        const that = this;
        const {error, isLoaded, isLoggedIn, isSubmitting, submitError, redirect, client} = this.state;
        if (redirect !== null) {
            window.location.reload();
            return (<LoadingSpin/>);
        } else {
            return (
                <React.Fragment>
                    {isSubmitting ? <LoadingSpin/> : ''}
                    {submitError !== null ? <ErrorMessage title="Pojawiły się błędy" text={submitError} buttons={[
                        {
                            'title': 'OK', 'callback': function () {
                                that.setState({submitError: null});
                            }
                        }
                    ]} handleClose={() => {
                        that.setState({submitError: null});
                    }}/> : ''}
                    <Container fluid={true} className="loginform">
                        <Row className="justify-content-md-center align-items-center">
                            <Col md={9} sm={12} lg={6} xl={4}>
                                <form className="loginform-form" onSubmit={this.handleSubmitForm}>
                                    <h2 className="loginform-form__header">Zaloguj się:</h2>
                                    <Form.Row className="loginform-form__row">
                                        <Form.Group as={Col} md={6} sm={12} controlId="formGridLogin">
                                            <Form.Label>
                                                Nazwa użytkownika:
                                            </Form.Label>
                                            <Form.Control name="login" type="text" placeholder="Wprowadź nazwę użytkownika" required={true}/>
                                        </Form.Group>
                                        <Form.Group as={Col} md={6} sm={12} controlId="formGridPassword">
                                            <Form.Label>
                                                Hasło:
                                            </Form.Label>
                                            <InputGroup>
                                                <Form.Control name="pass" type="password" placeholder="Wprowadź hasło" required={true}/>
                                            </InputGroup>
                                        </Form.Group>
                                    </Form.Row>
                                    <div className="loginform-form__buttons">
                                        <Button type="submit" name="submit">Zaloguj</Button>
                                    </div>
                                </form>
                            </Col>
                        </Row>
                    </Container>
                </React.Fragment>
            )
        }
    }
}

export default LoginForm;
